import type { RouteRecordRaw } from 'vue-router'

import { AUTHORIZATION_LAYOUT } from '@/router/constant'

const authorization: RouteRecordRaw = {
  path: '/authorization',
  name: 'Authorization',
  component: AUTHORIZATION_LAYOUT,

  children: [
    {
      path: '',
      name: 'TopView',
      component: () => import(/** webpackChunkName "initialize" */ '@/views/TopView.vue'),
      meta: { title: 'TOP 画面' },
    },

    {
      path: 'signup-guide',
      name: 'SignupGuide',

      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/SignupGuideView.vue'),

      meta: { title: 'サインアップ案内画面' },
    },

    {
      path: 'password-reset-complete',
      name: 'PasswordResetComplete',

      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/PasswordResetCompleteView.vue'
        ),

      meta: { title: 'パスワード登録完了画面' },
    },

    {
      path: 'signup-complete',
      name: 'SignupComplete',

      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/SignupCompleteView.vue'),

      meta: { title: '登録完了' },
    },
  ],
}

export default authorization
